import React, {useEffect, useState} from "react";
import styles from './DropdownMenu.module.css';

const DropdownMenu = ({
                          title,
                          char = "▼",
                          isSubmenu = false,
                          children,
                          align = "right",
                          relativeTo = "parent",
                          width = "180px",
                          status = false,
                          backgroundColor,
                          onClose,
                          customClass,
                      }) => {
    const [active, setActive] = useState(false);

    useEffect(() => {
        setActive(status);
    }, [status])

    useEffect(() => {
        if (active === false && typeof onClose === 'function') {
            onClose();
        }
    }, [active])

    const toggleDropdown = () => setActive(!active);

    const containerClass = isSubmenu ? styles.dropdownElement : styles.dropdownMenu;
    const textClass = isSubmenu ? styles.dropdownTextElement : styles.dropdownText;
    const charClass = `${styles.dropdownChar} ${active ? styles.dropdownInverted : ""}`;

    const dropdownStyle = {
        display: active ? 'block' : 'none',
        [align]: relativeTo === 'parent' ? '0' : undefined,
        position: relativeTo === 'parent' ? 'absolute' : 'fixed',
        top: '100%',
        width: width,
        borderRadius: align === 'right' ? '0 0 8px 8px' : '0 0 8px 8px',
        transform: active ? 'scaleY(1)' : 'scaleY(0)',
        opacity: active ? 1 : 0,
        backgroundColor: backgroundColor ? backgroundColor : '',
    };

    return (
        <div className={`${containerClass} ${customClass ? customClass : ""}`}>
            {(title !== "" || char !== "") && (
            <div className={textClass} onClick={toggleDropdown}>
                {title}
                <span className={charClass}>{char}</span>
            </div>)}
            <div className={styles.dropdownElements} style={dropdownStyle}>
                {children}
            </div>
        </div>
    );
};

export default DropdownMenu;